import Viagem from './viagem';

export default Viagem;